module.exports = __webpack_public_path__ + "img/62_6.fddeaaca.png";